import React from "react";
import { Button, EmptyState } from "@procore/core-react";
import { useI18nContext } from "@procore/core-react";
import { BrowserLocation } from "@/lib/utils/browser-location";

interface ErrorComponentProps {
   error?: Error;
}

export const ErrorComponent: React.FC<ErrorComponentProps> = () => {
   const I18n = useI18nContext();
   return (
      <EmptyState>
         <EmptyState.NoResults />
         <EmptyState.Title as="h2">
            {I18n.t("views.company.workforce_planning.errorBoundary.title")}
         </EmptyState.Title>
         <EmptyState.Description>
            {I18n.t("views.company.workforce_planning.errorBoundary.description")}
         </EmptyState.Description>
         <EmptyState.Actions>
            <Button
               onClick={() => {
                  BrowserLocation.reload();
               }}
            >
               {I18n.t("views.company.workforce_planning.errorBoundary.try_again")}
            </Button>
         </EmptyState.Actions>
      </EmptyState>
   );
};
